import React, {
  useEffect,
  // useState,
  useRef,
} from 'react'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import {
  Link, useParams, useLocation,
  useNavigate,
} from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import ReactPlayer from 'react-player'
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import styles from './BoughtEpisodeVideos.module.css'
import CourseEpisode from './CourseEpisode'
import {
  startLoading,
} from '../../../app/slices/loadingSlice'
import {
  getCourseVideo,
  selectorCourseVideo, selectorCourseVideos,
  getcourseVideos,
  sendVideoOffset,
  finishVideo,
} from '../../../app/slices/courseSlice'

const BoughtEpisodeVideos = () => {
  const video = useSelector(selectorCourseVideo)
  const courseVideos = useSelector(selectorCourseVideos)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { id } = useParams()

  const videoRef = useRef(null)

  const videosList = courseVideos?.filter((item) => +item?.id !== +id)

  const [isLoad, setIsLoad] = React.useState(false)

  useEffect(() => {
    dispatch(getCourseVideo(id))
  }, [])

  useEffect(() => {
    if (video?.courseId && video?.userId) {
      dispatch(getcourseVideos({ UserId: video?.userId, CourseId: video?.courseId }))
    }
  }, [videosList?.length, videosList?.length, video?.courseId, video?.userId, video?.offset])

  // useEffect(() => {
  //   dispatch(getCourseVideo(id))
  //   if (video?.courseId && video?.userId) {
  //     dispatch(getcourseVideos({ UserId: video?.userId, CourseId: video?.courseId }))
  //   }
  // }, [videosList?.length, id, videosList?.length, video?.courseId, video?.userId, video?.offset])

  useEffect(() => {
    if (video && video?.offset > 0) {
      console.log('offset', video?.offset)
      videoRef?.current?.seekTo(video?.offset)
      videoRef?.current?.target?.currentTime(video?.offset)
    }

    const setOffsetHandle = () => {
      const videoTag = document.querySelector('#course_video')
      if (video?.videoId && !videoTag?.paused && !videoTag?.ended && videoTag?.currentTime) {
        dispatch(sendVideoOffset(video?.videoId, Math.trunc(videoTag?.currentTime)))
      }
    }

    const sendSecond = setInterval(setOffsetHandle, 5000)

    return () => clearInterval(sendSecond)
  }, [courseVideos?.length, id, video?.videoUrl, dispatch,
    video?.coverUrl, video?.offset])

  let courseTime = null
  let courseTimeText = null

  if (video?.length / 60 < 1) {
    courseTime = video?.length.toFixed()
    courseTimeText = 'ثانیه'
  } else if (video?.length / 60 > 1) {
    courseTime = (video?.length / 60).toFixed()
    courseTimeText = 'دقیقه'
  } else if (video?.length / 60 > 60) {
    courseTime = ((video?.length / 60) / 60).toFixed()
    courseTimeText = 'ساعت'
  }

  return (
    <div className={styles.main}>

      <div
        style={{ width: '100%', display: 'flex', justifyContent: 'end' }}
      >
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => navigate(-1)}
          className={styles.Professional_course_details_header_time_back}
        >
          <p
            className={styles.Professional_course_details_header_time_back_text}
          >
            بازگشت

          </p>
          <p
            className={styles.Professional_course_details_header_time_back_btn}
          >
            <ArrowBackIcon />
          </p>
        </div>
      </div>

      <div className={styles.videoMain}>
        <div className={styles.video_header_description}>
          <div className={styles.video_header_description_right}>
            <span className={styles.video_header_description_text}>

              {video?.title}
            </span>
          </div>
          <div className={styles.video_header_description_time}>
            <AccessTimeIcon className={styles.video_header_description_time_icon} />
            <span className={styles.video_header_description_text}>
              مدت زمان ویدیو:
              {' '}
              {courseTime}
              {' '}
              {courseTimeText}
            </span>
          </div>
        </div>

        <div
          className={styles.video_body_wrap}
        >

          <ReactPlayer
            controls
            onReady={() => {
              setIsLoad(true)
            }}
            fallback={dispatch(startLoading())}
            config={{
              file: {
                attributes: {
                  poster: !isLoad && video?.coverUrl,
                  style: { objectFit: 'cover', width: '100%' },
                  className: styles.video_body_wrap_video,
                  controlsList: 'nodownload',
                  id: 'course_video',
                  onEnded: () => {
                    dispatch(finishVideo(video?.videoId))
                  },
                },

              },
              // forceHLS: true,
              // hlsOptions: {
              //   debug: false,
              //   xhrSetup(xhr, url) {
              //     // xhr.withCredentials = true
              //     if (video?.videoUrl && video?.token) {
              //       xhr.responseType = 'blob'
              //       xhr.open('GET', url, true)
              //       xhr.setRequestHeader('Authorization', `Bearer ${video?.token}`)
              //     }
              //   },
              // },
            }}
            url={video?.videoUrl}
            ref={videoRef}
            width="80%"
            height="auto"
            style={{ borderRadius: '20px !important' }}
            wrapper="div"
            playIcon={<PlayCircleOutlineIcon />}
            className={styles.react_player}
          />
        </div>
      </div>
      <div
        style={{ marginTop: '20px' }}
      >
        {videosList?.length ? (
          <span
            className={styles.video_header_description_other_text}
          >
            ویدیوهای دیگر

          </span>
        ) : null}

        {videosList?.length ? videosList?.map((item) => {
          let boughtCoursePercent = null
          // if (item?.offset && item?.videoUrl) {
          // boughtCoursePercent = Math.floor((item?.offset * item?.length) / 100)
          boughtCoursePercent = Math.floor((item?.offset / item?.length) * 100)
          // }

          const absoluetRoute = pathname?.substring(0, 60)

          console.log('boughtCoursePercent', item)

          const episodeId = item?.id
          const route = [absoluetRoute, episodeId].join('/')

          return (
            <Link
              to={route}
              // onClick={dispatch(getCourseVideo(id))}
            >
              <CourseEpisode
                course={item}
                boughtPercent={boughtCoursePercent || 0}
                bought
              />
            </Link>
          )
        }) : null}
      </div>
    </div>
  )
}

export default React.memo(BoughtEpisodeVideos)
